// @flow
import React, { useContext } from 'react'
import styled from 'styled-components'

import { DesignContext } from '../store'
import { colors } from '../styles'

type Props = {
  onChangeBoard: Function,
}

const HeaderTabs = ({ onChangeBoard }: Props): Function => {
  const { state } = useContext(DesignContext)
  const { boards, currentBoardIndex } = state

  const changeBoard = (evt) => onChangeBoard(evt.target.dataset.boardIndex)

  return (
    <Panel className="no-print">
      <TabContainer>
        <Tabs onClick={changeBoard} data-current-board={currentBoardIndex}>
          {boards.map((board, i) => (
            <Tab key={`tab-${i}`} data-board-index={i}>{board.label}</Tab>
          ))}
        </Tabs>
      </TabContainer>
    </Panel>
  )
}

export default HeaderTabs

const Panel = styled.div`
  padding: 1rem 10px 0;
`

const TabContainer = styled.div`
  //border: 1px solid ${colors.midGray};
`

const Tab = styled.div`
  background: #fff;
  font-size: 16px;
  white-space: nowrap;
  border: 1px solid ${colors.midGray};
  padding: 10px 9px 4px 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  
  &:not(:first-child) {
    border-left-color: transparent;
  }
  
  
  &.active {
    border-bottom-color: transparent;
  }
`

const Tabs = styled.div`
  display: flex;
  flex-wrap: nowrap; 
  justify-content: stretch;
  width: 100%;
  margin-bottom: 0.5rem;
  
  &[data-current-board="0"] ${Tab}:nth-child(1),
  &[data-current-board="1"] ${Tab}:nth-child(2),
  &[data-current-board="2"] ${Tab}:nth-child(3) {
     //border-bottom-width: 3px;
     background-color: ${colors.midGray};
     color: #fff;
  }
`
